import type { SupabaseClient } from "@supabase/supabase-js";
import React, { createContext, useContext, useMemo } from "react";

import { supabase } from "../lib/supabase";

const SupabaseContext = createContext<SupabaseClient | undefined>(undefined);

export interface SupabaseProviderProps {
  children: React.ReactNode;
  client?: SupabaseClient;
}

export const SupabaseProvider: React.FC<SupabaseProviderProps> = ({
  children,
  client,
}) => {
  const resolvedClient = useMemo(() => client ?? supabase, [client]);

  return (
    <SupabaseContext.Provider value={resolvedClient}>
      {children}
    </SupabaseContext.Provider>
  );
};

export const useSupabaseClient = (): SupabaseClient => {
  const context = useContext(SupabaseContext);
  if (context === undefined) {
    throw new Error("useSupabaseClient must be used within a SupabaseProvider");
  }
  return context;
};
